import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'mapObject' })
export class MapObjectPipe implements PipeTransform {
  transform(input: any, output: any): any {
    //var destination_model = new T();
    if (!output || !input) {
      return;
    }
    const destination = Object.keys(output);
    const source = Object.keys(input);
    source.forEach(key => {
      if (destination.some(el => el === key)) {
        output[key] = input[key];
      };
    });
    return output;
  }
}
